// src/App.jsx - Add new routes
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Publications from './pages/Publications';
import PublicationDetail from './pages/PublicationDetail';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';  // New
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';    // New
import Services from './pages/Services';
import Contact from './pages/Contact';


function App() {
  return (
    <div className="portfolio-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/publications/:id" element={<PublicationDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />     {/* New */}
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetail />} />       {/* New */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;